import { useState } from "react";
import { useSearchParams, useParams } from "react-router-dom";

import { userApi } from "../../api";
import LoginForm, { SubmitLogin } from "../../components/loginForm";

import MedicAirSmartLogo from "../../assets/MedicAirSmartLogo";
import classes from "./index.module.scss";

const OAuthPage = () => {
  let [searchParams] = useSearchParams();
  let { clientType } = useParams();
  
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [errMsg, setErrMsg] = useState<string>("");

  const handleSubmit = async ({ e, email, password }: SubmitLogin) => {
    e.preventDefault();
    setIsLoading(true);

    const clientId = searchParams.get("client_id")!
    const redirectURI = searchParams.get("redirect_uri")!
    const state = searchParams.get("state")!

    const payload = { email, password, clientId, clientType: clientType || "none" };

    await userApi.oauthLogin(payload).then((res) => {
      if (res.status >= 400) {
        setErrMsg("Email or password are incorrect");
        setIsLoading(false);
        return;
      }

      setIsLoading(false);

      window.location.href = `${redirectURI}?code=${res.params.authCode}&state=${state}`;
    });
    
    setTimeout(() => setErrMsg(""), 2500);
    
  };

  return (
    <div
      style={{
        height: "100vh",
        flexDirection: "row",
        display: "flex",
      }}
    >
      <div className={classes.formContainer}>
        <div className={classes.logo}>
          <MedicAirSmartLogo />
        </div>
        <LoginForm
          title={`Link Your MedicAir Account to ${
            clientType === "google" ? "Google" : "Amazon Alexa"
          }`}
          subtitle={`By signing in, you are authorizing ${
            clientType === "google" ? "Google" : "Amazon Alexa"
          } to control your devices`}
          handleSubmit={handleSubmit}
          loading={isLoading}
          error={errMsg}
        />
      </div>
    </div>
  );
};

export default OAuthPage;
